export function PlaylistIcon({ className }: { className?: string }) {
  return (
    <svg 
      width="35" 
      height="27" 
      viewBox="0 0 35 27" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M15.2051 8.86616L0.615235 16.9741C0.274659 17.1609 0 16.9961 0 16.6115V0.439641C0 0.0551188 0.274659 -0.109676 0.615235 0.0770916L15.2051 8.18501C15.5457 8.37178 15.5457 8.6794 15.2051 8.86616Z" 
        fill="currentColor"
      />
      <path 
        d="M22.9688 4.61938H33.9062" 
        stroke="currentColor" 
        strokeWidth="2.1875" 
        strokeLinecap="square"
      />
      <path 
        d="M14.2188 18.6558H33.9062" 
        stroke="currentColor" 
        strokeWidth="2.1875" 
        strokeLinecap="square"
      />
      <path 
        d="M22.9688 11.6376H33.9062" 
        stroke="currentColor" 
        strokeWidth="2.1875" 
        strokeLinecap="square"
      />
      <path 
        d="M1.09375 25.6741H33.9062" 
        stroke="currentColor" 
        strokeWidth="2.1875" 
        strokeLinecap="square"
      />
    </svg>
  );
}